// Page-level strings for the Lifecycle view (TASK-033). Composing-widget
// strings stay inside their respective widgets — this dictionary covers
// page chrome (title, header CTA, error/empty/loading states).

export const LIFECYCLE_PAGE_STRINGS = {
  pageTitle: "Lifecycle",
  loading: "Loading lifecycle distribution…",
  errorTitle: "We couldn't load the lifecycle trend",
  errorBodyDefault: "Something went wrong fetching your community data.",
  retry: "Retry",
  noCommunity: {
    title: "No community connected yet",
    body: "Open the bot in Telegram and follow the prompts to add your first community.",
  },
} as const;

export type LifecyclePageStrings = typeof LIFECYCLE_PAGE_STRINGS;
